module.exports = __webpack_public_path__ + "img/cover-page.ccbdd796.jpg";